import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AuthzPermissionGroup = React.lazy(() =>
    import('../AuthzPermissionGroup')
);
const authzPermissionGroupRoutesRegistry = [
    {
        path: PAGE_URL.AUTHZ_PERMISSION_GROUP_PAGE,
        element: <AuthzPermissionGroup />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default authzPermissionGroupRoutesRegistry;
